import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import Gallery from '../beforeAfterGallery'

const HomepageGallery = ({ navigateLink }) => (
  <Box
    sx={{
      py: 6,
    }}
  >
    <Box
      width={1}
      sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}
    >
      {/* Text side */}
      <Box
        width={{ xs: 1, md: 0.44 }}
        height={{ xs: 'auto', md: '400px' }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: { xs: 'flex-start', md: 'center' },
        }}
      >
        <Box
          width={{ md: 0.9 }}
          sx={{
            px: 3,
            pb: { xs: 3, md: 0 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{ color: '#f5f7f6', fontWeight: 700 }}
          >
            Our Transformations
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#d7e3dd',
              mt: 2,
              fontSize: '16px',
            }}
          >
            At Read Landscaping, quality and customer satisfaction are at the
            center of every project we undertake.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#d7e3dd',
              my: 2,
              fontSize: '16px',
            }}
          >
            Explore the remarkable transformations we've brought to life. Each
            project is a testament to our commitment to quality and attention to
            detail. From lush gardens to modern patios, see how we've turned
            visions into reality, one project at a time.
          </Typography>

          <Button
            size="large"
            sx={{
              backgroundColor: '#8FAA30',
              color: '#015f44',
              p: 1.5,
              px: 4,
              textTransform: 'none',
              mx: 'auto',
              mt: 2,
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#9fc23c',
              },
            }}
            onClick={() => navigateLink('/portfolio')}
          >
            View More Transformations
          </Button>
        </Box>
      </Box>

      {/* Gallery side */}
      <Box
        width={{ xs: 1, md: 0.56 }}
        height={{ xs: 'auto', md: '400px' }}
        sx={{
          border: { md: '4px solid #8FAA30' },
        }}
      >
        <Gallery height="400px" maxSlides={2} />
      </Box>
    </Box>
  </Box>
)

export default HomepageGallery
